export const TRAINING_PATH = "/child-protection/clearances/training";

export const SESSION_FOR_SEVERAL_PATH = `${TRAINING_PATH}/session`;

export const personTrainingPath = (personId: string) => `${TRAINING_PATH}/${personId}`;
